<template>
  <div class="header">
    <div class="name">
      <!-- <back-page /> -->
      <h3>我的投递</h3>
    </div>
  </div>
  <!-- 卡片式岗位列表 -->
  <div class="job_list">
    <!-- <div class="job_item" v-for="item in deliverJob" :key="item.id" :class="{ winner: item.resumeStatus == 1 || item.resumeStatus > 2 }"> -->
    <div class="job_item" v-for="item in deliverJob" :key="item.id">
      <div class="name">{{ item.jobName }}</div>
      <div class="info">
        <div class="info_dept">{{ isSpecific ? '招聘单位' : '招聘部门' }}：{{ item.deptName }}</div>
        <div class="info_edu" v-if="!isSpecific">学历要求：{{ item.educationNeed }}</div>
        <div class="info_num">招聘人数：{{ item.needNum }}人</div>
        <div class="info_num" v-if="!isSpecific && item.remark">是否应届：{{ item.remark }}</div>
        <div class="info_num" v-if="isSpecific">已投递人数：{{ item.applicantNum || 0 }}人</div>
        <div class="info_num" v-if="isSpecific">已通过审核人数：{{ item.passNum || 0 }}人</div>
      </div>
      <!-- <div class="info desc">
        <p class="title">职位描述：</p>
        <p>{{ item.jobDescription }}</p>
      </div> -->
      <!-- <div class="info desc">
        <p class="title">岗位要求：</p>
        <p>{{ item.jobNeed }}</p>
      </div> -->
      <template v-if="isSpecific">
        <div class="status" v-if="item.resumeStatus == -1">
          <p class="title remark">状态：退回补充材料</p>
          <p style="margin-top: 10px">{{ item.reason || '未知原因，请联系报考单位' }}</p>
        </div>
        <div class="status" v-else>
          <p class="title" :class="item.resumeStatus == 2 ? 'remark' : 'success'">
            状态：{{ item.resumeStatus == 2 ? '审核不通过' : item.resumeStatus == 1 || item.resumeStatus > 2 ? '审核通过' : '审核中...' }}
          </p>
        </div>
      </template>
      <div class="actions">
        <el-button type="primary" plain size="small" @click="goResume">{{ item.resumeStatus == -1 ? '修改简历' : '查看简历' }}</el-button>
        <el-button v-if="!isSpecific" type="primary" size="small" @click="cancelFunc(item)">取消投递</el-button>
      </div>
    </div>
    <el-empty v-if="!loading && !deliverJob.length" :image-size="140" description="暂无投递信息"> </el-empty>
  </div>
</template>

<script>
import { onActivated, reactive, toRefs, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BackPage from '../components/BackPage.vue';

import ApplicantApi from '../service/api/applicant';
import { formatDate } from '../utils/tools';
import { ElMessage } from 'element-plus';

export default {
  name: 'Deliver',
  components: { BackPage },
  setup() {
    const state = reactive({
      deliverJob: [],
      loading: true,
    });

    const store = useStore();
    let timer = null;
    const getDeliverList = () => {
      if (timer) return;
      timer = setTimeout(async () => {
        clearTimeout(timer);
        timer = null;
        const userInfo = store.state.userInfo;
        if (userInfo && userInfo.basicId) {
          state.loading = true;
          try {
            const respond = await ApplicantApi.getMyDeliver(userInfo.basicId);
            state.deliverJob = respond;
            // state.deliverJob = respond.sort((a, b) => Date.parse(b.createTime) - Date.parse(a.createTime)).slice(0, 1);
          } catch {
            state.deliverJob = [];
          }
        }
        state.loading = false;
      }, 100);
    };
    watch(() => store.state.userInfo, getDeliverList);

    onActivated(() => getDeliverList());

    const cancelFunc = async (item) => {
      //  取消投递
      try {
        await ApplicantApi.deletedeliver(item.id);
        ElMessage.success('取消成功');
        getDeliverList();
      } catch (e) {
        console.error('取消投递失败', e);
      }
    };

    const router = useRouter();
    const goResume = () => {
      if (store.state.isMobile) {
        return ElMessage.warning('为了更好地体验，请在PC端登录投递');
      }
      router.push('/resume');
    };

    const dicOptions = computed(() => store.state.dicOptions);
    const isSpecific = computed(() => store.state.isSpecific); //是否是专项招聘
    return {
      router,
      ...toRefs(state),
      getDeliverList,
      formatDate,
      cancelFunc,
      goResume,
      dicOptions,
      isSpecific,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../style/func.scss';
.header {
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
  box-shadow: 0 0 4px #bebebe;
  padding: 10px 10px 6px 10px;
  font-size: 16px;
  .name {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    h3 {
      padding: 0 30px;
      flex: 1;
      white-space: nowrap;
    }
  }
}

.job_list {
  padding: rem(40px);
  font-size: rem(14px);
  .job_item {
    border-radius: 4px;
    border: 1px solid rgba(102, 102, 102, 0.1);
    box-shadow: 0 2px 4px #f9f9f9;
    margin-bottom: 20px;
    position: relative;
    // overflow: hidden;
    &:hover {
      background: #f9f9f9;
    }
    &::before {
      content: '';
      width: 130px;
      height: 130px;
      position: absolute;
      background-repeat: no-repeat;
      background-size: contain;
      top: -20px;
      right: 0;
    }
    &.winner {
      &::before {
        background-image: url('../assets/done.jpg');
      }
    }
    .name {
      margin-bottom: 6px;
      padding: 0 10px;
      height: 40px;
      color: #ed4013;
      border-bottom: 1px solid #f7f7f7;
      font-size: 18px;
      display: flex;
      align-items: center;
    }
    .info {
      padding: 6px 10px;
      font-size: 16px;
      color: #363e4f;
      &_dept {
        width: 28%;
      }
      &_edu {
        width: 25%;
      }
      &_num {
        width: 20%;
      }
      > div {
        display: inline-block;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
      &.desc {
        font-size: 14px;
        display: block;
        .title {
          font-weight: 600;
          margin-bottom: 6px;
          font-size: 15px;
        }
      }
      .remark {
        color: #ed4013;
      }
      .success {
        color: #0eb77b;
      }
    }
    .status {
      border: 1px solid #f7f7f7;
      box-shadow: 0 0 4px #bebebe;
      margin: 20px 20px 0;
      border-radius: 4px;
      padding: 10px 20px;
      font-size: 14px;
      .title {
        font-weight: 600;
        font-size: 15px;
      }
      .remark {
        color: #ed4013;
      }
      .success {
        color: #0eb77b;
      }
    }
    .actions {
      margin-top: 20px;
      padding: 0 10px;
      height: 46px;
      border-top: 1px solid #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

@media screen and (max-width: 600px) {
  .job_list {
    padding: rem(20px);
    .actions {
      margin-top: 0;
    }
  }
}
</style>
